import React, { useState, useEffect } from 'react';
import './ReorderBreakdown.css';

const STATUS = {
  needs: { label: 'Re-Order Now', color: '#c0392b' },
  soon: { label: 'Re-Order Soon', color: '#d97706' },
  ok: { label: 'Good', color: '#1f9d55' },
};

function ReorderBreakdown({ schoolId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!schoolId) return;
    let cancelled = false;
    setLoading(true);
    const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
    const username = localStorage.getItem('admin_username');
    const password = localStorage.getItem('admin_password');
    fetch(`${apiEndpoint}/admin/schools/${schoolId}/reorder`, {
      headers: { 'Authorization': 'Basic ' + btoa(`${username}:${password}`) },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled) setData(d); })
      .catch(() => { if (!cancelled) setData(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [schoolId]);

  if (loading && !data) return <div className="reorder-bd"><div className="reorder-empty">Loading…</div></div>;
  if (!data) return <div className="reorder-bd"><div className="reorder-empty">No reorder data.</div></div>;

  const totals = data.totals || [];
  return (
    <div className="reorder-bd">
      <div className="reorder-stats">
        <div className="reorder-stat">
          <div className="reorder-stat-value">{(data.totalGood ?? 0).toLocaleString()}</div>
          <div className="reorder-stat-label">Good products (asset condition)</div>
        </div>
        <div className="reorder-stat">
          <div className="reorder-stat-value">{(data.totalCapacity ?? 0).toLocaleString()}</div>
          <div className="reorder-stat-label">Total capacity (all slots)</div>
        </div>
        <div className="reorder-stat">
          <div className="reorder-stat-value">{(data.totalBags ?? 0).toLocaleString()}</div>
          <div className="reorder-stat-label">Total products</div>
        </div>
      </div>

      {totals.length === 0 ? (
        <div className="reorder-empty">No products at this school.</div>
      ) : (
        <table className="reorder-table">
          <thead>
            <tr>
              <th>Product</th>
              <th className="num">Lost</th>
              <th className="num">Damaged</th>
              <th className="num">Good</th>
              <th className="num">Total</th>
              <th className="num">Capacity</th>
              <th className="num">Assigned</th>
              <th>Re-order</th>
            </tr>
          </thead>
          <tbody>
            {totals.map((t) => {
              const st = STATUS[t.reorderStatus] || STATUS.ok;
              return (
                <tr key={t.sku}>
                  <td>{t.displayName}{t.nonFaraday ? ' (non-Faraday)' : ''}</td>
                  <td className="num">{t.lost ?? 0}</td>
                  <td className="num">{t.damaged ?? 0}</td>
                  <td className="num">{t.good ?? 0}</td>
                  <td className="num">{t.total ?? 0}</td>
                  <td className="num">{t.capacity ?? 0}</td>
                  <td className="num">{t.assignedToStudents ?? 0}</td>
                  <td style={{ color: st.color, fontWeight: 600 }}>{st.label}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ReorderBreakdown;
